import React from 'react';
import { Button, Space, Tooltip } from 'antd';
import {
  CheckOutlined,
  QuestionCircleOutlined,
  StopOutlined,
} from '@ant-design/icons';

const POLICY_OPTIONS = [
  { value: 'always_allow', icon: CheckOutlined, label: 'Always allow' },
  { value: 'need_approval', icon: QuestionCircleOutlined, label: 'Need approval' },
  { value: 'blocked', icon: StopOutlined, label: 'Blocked' },
];

export default function ToolPolicyIconSelector({ value, onChange, size = 'small' }) {
  return (
    <Space.Compact
      className="tool-policy-icon-selector"
      onClick={(e) => e.stopPropagation()}
    >
      {POLICY_OPTIONS.map(({ value: policyValue, icon: Icon, label }) => (
        <Tooltip key={policyValue} title={label}>
          <Button
            type={value === policyValue ? 'primary' : 'default'}
            size={size}
            icon={<Icon />}
            aria-label={label}
            aria-pressed={value === policyValue}
            onClick={() => onChange?.(policyValue)}
          />
        </Tooltip>
      ))}
    </Space.Compact>
  );
}
